/**
 * 演出速度
 */
export enum EffectSpeed {
  /** 低速 */
  SLOW = 'slow',
  /** 通常速度 */
  NORMAL = 'normal',
  /** 高速 */
  FAST = 'fast',
}

/**
 * ゲーム設定
 */
/** 制限時間の選択肢（秒） */
export const TIME_LIMIT_OPTIONS = [60, 90, 120] as const;
export type TimeLimitSeconds = typeof TIME_LIMIT_OPTIONS[number];

export interface Settings {
  /** BGM音量（0〜100の整数） */
  bgmVolume: number;
  /** SE音量（0〜100の整数） */
  seVolume: number;
  /** 演出速度 */
  effectSpeed: EffectSpeed;
  /** 制限時間（秒）: 60 / 90 / 120 */
  timeLimitSeconds?: TimeLimitSeconds;
}

/** デフォルト設定値 */
export const DEFAULT_SETTINGS: Settings = {
  bgmVolume: 80,
  seVolume: 80,
  effectSpeed: EffectSpeed.NORMAL,
  timeLimitSeconds: 90,
};

/**
 * 音量を0〜100の整数にクランプする
 */
export function clampVolume(volume: number): number {
  return Math.max(0, Math.min(100, Math.round(volume)));
}

/**
 * 有効な演出速度かどうかを判定する
 */
export function isValidEffectSpeed(speed: string): speed is EffectSpeed {
  return speed === EffectSpeed.SLOW || speed === EffectSpeed.NORMAL || speed === EffectSpeed.FAST;
}

/**
 * Settings型のバリデーション
 */
export function isValidSettings(obj: unknown): obj is Settings {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return false;
  }

  const candidate = obj as Record<string, unknown>;

  const validTime =
    candidate.timeLimitSeconds === undefined ||
    (typeof candidate.timeLimitSeconds === 'number' &&
      (TIME_LIMIT_OPTIONS as readonly number[]).includes(candidate.timeLimitSeconds));

  return (
    typeof candidate.bgmVolume === 'number' &&
    typeof candidate.seVolume === 'number' &&
    typeof candidate.effectSpeed === 'string' &&
    isValidEffectSpeed(candidate.effectSpeed) &&
    validTime
  );
}
